<template>
    <div class="card rounded-lg" style="overflow: hidden;">
        <div class="card-header">
            <div class="d-flex justify-content-between align-items-center">
                <div>{{ $t('teammates') }}</div>
                <div class="">{{ teammates.length }}</div>
            </div>
        </div>
        <div class="card-body p-0">
            <app-pre-loader v-if="teammatesLoading"/>
            <template v-else>
                <div class="d-flex flex-column scroll-y custom-scrollbar" style="max-height: 380px;">
                    <a v-for="(mate, index) in teammates" :href="urlGenerator('/profile/' + mate.uuid)"
                       class="d-flex align-items-center gap-x-1 py-2 px-3 text-dark teammate" :key="`teammates-item-${index}`">
                        <img width="30" height="30" class="rounded-circle"
                             :src="mate?.profile_picture?.full_url || urlGenerator('/images/avatar-demo.jpg')" alt="">
                        <span>{{ mate.full_name }}</span>
                    </a>
                    <app-empty-data-block v-if="!teammates.length && !loading" :message="$t('empty_data_block_team')"
                                          style="padding: 0 !important"/>
                </div>
            </template>
        </div>
    </div>
</template>

<script>
import {mapGetters} from "vuex";
import {urlGenerator} from "../../../../../helpers/AxiosHelper";

export default {
    data() {
        return {
            urlGenerator
        }
    },
    computed: {
        ...mapGetters({
            teammates: 'teammates/list',
            teammatesLoading: 'teammates/loading'
        })
    },
    created() {
        this.$store.dispatch('teammates/getAll')
    }
}
</script>

<style scoped lang="scss">
.teammate {
    &:hover {
        background-color: #dddddd50;
        color: #000 !important;
    }
}
</style>